"use client";

import type { DividerProps as _DividerProps } from "@chakra-ui/react";
import { Divider as _Divider, forwardRef } from "@chakra-ui/react";

export interface DividerProps extends _DividerProps {}

export const Divider = forwardRef<DividerProps, "div">(({ ...props }, ref) => (
    <_Divider ref={ref} {...props} />
));
